/**
 * Phase-1 mocks — everything backed by localStorage so product can
 * iterate on the UX before the backend exists.
 *
 * Keys are namespaced under `dsr_setup:` to isolate from other app
 * signals and to make manual DevTools inspection trivial.
 *
 * When Phase 2 lands and real APIs come online, swap the `load`/`save`
 * calls with `fetch()` — the shape of the objects is deliberately
 * close to what the tables will end up storing.
 */

const NS = 'dsr_setup:'

export function loadKey(key, fallback) {
	try {
		const raw = localStorage.getItem(NS + key)
		return raw ? JSON.parse(raw) : fallback
	} catch {
		return fallback
	}
}

export function saveKey(key, value) {
	try {
		localStorage.setItem(NS + key, JSON.stringify(value))
		// Notify same-tab listeners (storage event fires cross-tab only).
		window.dispatchEvent(new CustomEvent(`${NS}${key}:change`, { detail: value }))
	} catch (err) {
		console.warn('dsr_setup: could not persist', key, err)
	}
}

export function subscribeKey(key, cb) {
	const handler = (e) => cb(e.detail)
	window.addEventListener(`${NS}${key}:change`, handler)
	return () => window.removeEventListener(`${NS}${key}:change`, handler)
}

// Small helpers reused across tabs.
export const uid = () => Math.random().toString(36).slice(2, 10)

export const fmtMoney = (n) =>
	n == null ? '—' : new Intl.NumberFormat('es-ES', {
		style: 'currency', currency: 'EUR', maximumFractionDigits: 0,
	}).format(n)

export const fmtNum = (n) =>
	n == null ? '—' : new Intl.NumberFormat('es-ES').format(n)

export const fmtPct = (n) =>
	n == null ? '—'
	: new Intl.NumberFormat('es-ES', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
		.format(n) + '%'
